// AgentNode.js
import React from 'react';
import { Handle } from 'reactflow';
import { FiUser } from 'react-icons/fi'; // Example: Using react-icons, install if needed (npm install react-icons)

const AgentNode = ({ id, data }) => {
  const statusStyles = {
    idle: 'border-zinc-600', // Default border
    pending: 'border-yellow-400',
    queued: 'border-blue-400',
    failed: 'border-red-500',
    success: 'border-green-500',
    running: 'border-green-500 animate-pulse', // Pulse the border for running
    approvalNeeded: 'border-orange-500 animate-[glow_1.5s_infinite]',
    diagnosing: 'animate-[pulse_1s_infinite] border-purple-500', // 👈 new line
  };

  const status = data?.status || 'idle';
  const currentBorderColor = statusStyles[status] || statusStyles.idle;
  const isLoading = status === 'running' || status === 'pending';

  return (
    <div
      className={`relative h-28 w-48 rounded-xl border-2 bg-zinc-800 shadow-xl ${currentBorderColor} flex flex-col items-center justify-center p-3 transition-colors duration-300 ease-in-out`}
    >
      {/* Agent Icon */}
      <div className="mb-2 rounded-full bg-zinc-700 p-2">
        {/* Placeholder for a more specific agent icon */}
        <FiUser className="h-6 w-6 text-blue-400" />
      </div>

      {/* Agent Name */}
      <div
        className="w-full truncate px-1 text-center text-sm font-medium text-zinc-100"
        title={data?.agent_name || 'Select Agent'}
      >
        {data?.agent_name || 'N/A'}
      </div>

      {/* Small "Agent" label */}
      <div className="mt-1 text-xs text-zinc-400">Agent</div>

      {/* Loading Indicator (Optional, can be part of status styling) */}
      {isLoading && (
        <div className="absolute right-2 top-2 h-3 w-3 animate-spin rounded-full border-2 border-zinc-400 border-t-white" />
      )}

      {/* Output Handle */}
      <Handle
        type="source"
        position="bottom"
        className="!border-none !bg-[#5652CF] !shadow-md"
        style={{
          bottom: '-6px', // Slightly offset for better visibility against the border
          height: '10px',
          width: '10px',
          borderRadius: '50%',
        }}
      />
    </div>
  );
};

export default AgentNode;
